// extracted by mini-css-extract-plugin
module.exports = {"content":"src-layout-BasicLayout-module__content--RQir3"};